<template>
<div class="content-class">
	<v-tabs v-model="active" color="black" dark slider-color="primary">
		<v-tab :key="'userGroups'" ripple>Clinique</v-tab>
		<v-tab :key="'subBot'" ripple>Logs</v-tab>

		<v-tab-item :key="'userGroups'">
			<user-group-form v-model="document">
			</user-group-form>

			<v-btn @click="remove" color="error">Supprimer</v-btn>

			<user-list ref="userList" :url="'users?filter=bots.bot:$eq:'+$route.params.botId+';userGroups:$elemMatch:$eq:'+$route.params.userGroupId" :added-items="deleteUser">
			</user-list>

			<user-list ref="userListNot" :url="'users?filter=bots.bot:$eq:'+$route.params.botId+';userGroups:$nElemMatch:$eq:'+$route.params.userGroupId" :added-items="addUser">
			</user-list>
		</v-tab-item>

		<v-tab-item :key="'Logs'">
			<log-list :url="'logs?filter=references.reference:$eq:userGroups;references.referenceId:$eq:'+$route.params.userGroupId">
			</log-list>
		</v-tab-item>
	</v-tabs>
</div>
</template>

<script>
import UserGroupForm from '../../components/userGroups/userGroup.form'
import LogList from '../../components/logs/log.list.vue'
import UserList from '../../components/users/user.list'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { UserList, UserGroupForm, LogList },
	methods: {
		remove() {
			this.axios
				.delete('userGroups/' + this.$route.params.userGroupId)
				.then(response => {
					this.$store.dispatch(SUCCESS, 'Clinique supprimée')
					this.$router.push({ name: 'UserGroupList', params: { botId: this.$route.params.botId } })
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		}
	},
	data() {
		return {
			active: null,
			document: null,
			addUser: [{
				header: 'Ajouter',
				icon: () => 'add',
				cellClick: (item) => {
					this.axios
						.post('userGroups/' + this.$route.params.userGroupId + '/users/' + item._id)
						.then(response => {
							this.$store.dispatch(SUCCESS, 'Utilisateur ajouté à la clinique')
							this.$refs.userList.update()
							this.$refs.userListNot.update()
						})
						.catch((err) => {
							this.$store.dispatch(ERROR, err)
						})
				}
			}],
			deleteUser: [{
				header: 'Supprimer',
				icon: () => 'delete',
				cellClick: (item) => {
					this.axios
						.delete('userGroups/' + this.$route.params.userGroupId + '/users/' + item._id)
						.then(response => {
							this.$store.dispatch(SUCCESS, 'Utilisateur supprimé de la clinique')
							this.$refs.userList.update()
							this.$refs.userListNot.update()
						})
						.catch((err) => {
							this.$store.dispatch(ERROR, err)
						})
				}
			}]
		}
	},
	mounted() {
		this.axios
			.get('userGroups/' + this.$route.params.userGroupId)
			.then(response => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	}

}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/userGroups/userGroup.detail.vue